<template>
	<div  class="scrollable only-y" v-loading.fullscreen.lock="fullScreenLoading">
    <div class="customer-top-nav">
			<span class="title" >Champs personnalisés</span>
			<div class="controls">
				<el-button @click="close();">{{$t('buttons.close')}}</el-button>
			</div>
		</div>
    <el-tabs tab-position="top" style="height: 200px;">
      <el-tab-pane label="Clients">
        <p>Section pour gérer les champs personnalisés associés à une fiche client.</p>
        <p>Dans cette section vous pouvez : </p>
        <ul>
          <li><strong>Ajouter de nouveaux champs</strong>. Suite à l'enregistrement des nouveaux champs, ceux-ci seront immédiatement disponibles dans les fiches clients.</li>
          <li><strong>Modifiez les libellés</strong> des champs personnalisés.</li>
          <li><strong>Supprimer la configuration</strong> d'un champ personnalisé. <strong>Attention</strong>, lorsque vous supprimer un champs peronnalisé vous perderez les informations déjà saisit dans ce champs.</li>
        </ul>
        <h3>Champs personnalisés de la fiche client : </h3>
        <el-form label-position="top">
          <el-row v-for="(field, i) in customer_fields" :key="field.id">
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="6">
              <el-form-item  :label="getCustomFieldLabel(field)" style="margin-bottom:0px;">
                <el-input v-model="customer_fields[i].title"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="4" :xl="4" style="margin-top:30px;margin-left:10px;">
                <el-button type="danger" icon="el-icon-delete" circle @click="deleteCustomFields('CUSTOMER_CUSTOM_FIELD',i)"></el-button>
            </el-col>
          </el-row>
          <el-tooltip class="item" effect="dark" content="Ajouter un nouveau champ personnalisé" placement="top-start">
            <el-button type="default" @click="newCustomField('CUSTOMER_CUSTOM_FIELD')">Ajouter</el-button>
          </el-tooltip>
          <el-button type="primary" @click="saveCustomFields('CUSTOMER_CUSTOM_FIELD')">Enregistrer</el-button>
        </el-form>
      </el-tab-pane>
			<el-tab-pane label="Bons de commande">
        <p>Section pour gérer les champs personnalisés associés aux bons de commande.</p>
        <p>Dans cette section vous pouvez : </p>
        <ul>
          <li><strong>Ajouter de nouveaux champs</strong>. Suite à l'enregistrement des nouveaux champs, ceux-ci seront immédiatement disponibles dans les fiches clients.</li>
          <li><strong>Modifiez les libellés</strong> des champs personnalisés.</li>
          <li><strong>Supprimer la configuration</strong> d'un champ personnalisé. <strong>Attention</strong>, lorsque vous supprimer un champs peronnalisé vous perderez les informations déjà saisit dans ce champs.</li>
        </ul>
        <h3>Champs personnalisés des bons de commande: </h3>
        <el-form label-position="top">
          <el-row v-for="(field, i) in PO_fields" :key="field.id">
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="6">
              <el-form-item  :label="getCustomFieldLabel(field)" style="margin-bottom:0px;">
                <el-input v-model="PO_fields[i].title"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6" :lg="4" :xl="4" style="margin-top:30px;margin-left:10px;">
                <el-button type="danger" icon="el-icon-delete" circle @click="deleteCustomFields('PO_CUSTOM_FIELD',i)"></el-button>
            </el-col>
          </el-row>
          <el-tooltip class="item" effect="dark" content="Ajouter un nouveau champ personnalisé" placement="top-start">
            <el-button type="default" @click="newCustomField('PO_CUSTOM_FIELD')">Ajouter</el-button>
          </el-tooltip>
          <el-button type="primary" @click="saveCustomFields('PO_CUSTOM_FIELD')">Enregistrer</el-button>
        </el-form>
      </el-tab-pane>
    </el-tabs>
	</div>
</template>

<script>
import axios from "axios"
import SystemAPI from '@/services/API/system'

export default {
  data() {
    return {
      fullScreenLoading : true,
      customer_fields : [],
      customer_changed : false,
			PO_fields : [],
			PO_changed : false,

    };
  },components: {

  },
	methods: {
    close(){
			this.$router.go(-1);
		},
    getCustomFieldLabel(field){
      return "Libellé du champ personnalisé " + field.key;
    },
    newCustomField(module){
      var tmp = {};
      var last = null;
			if(module=="CUSTOMER_CUSTOM_FIELD"){
				last=_.last(this.customer_fields);
	      tmp.key = last.key+1;
	      tmp.title = ""
	      this.customer_fields.push(tmp);
			}else if(module=="PO_CUSTOM_FIELD"){
				last=_.last(this.PO_fields);
				tmp.key = last.key+1;
				tmp.title = ""
				this.PO_fields.push(tmp);
			}

    },
    saveCustomFields(module){

			var fields = [];

			if(module=="CUSTOMER_CUSTOM_FIELD"){
				_.forEach(this.customer_fields, field=>{
					field.value = {};
					field.value.title = field.title;
					field.module = "CUSTOMER_CUSTOM_FIELD";
					fields.push(field);
				})
			}else if (module=="PO_CUSTOM_FIELD"){
				_.forEach(this.PO_fields, field=>{
					field.value = {};
					field.value.title = field.title;
					field.module = "PO_CUSTOM_FIELD";
					fields.push(field);
				})
			}

      axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/custom-fields", fields)
        .then(response=>{
          this.$notify({
            title: 'Succès',
            message: 'Champs personnalisés sauvegardés avec succès',
            type: 'success'
          });
        }).catch(err=>{

        })
    },
		splice(module, index){
				if(module=="CUSTOMER_CUSTOM_FIELD"){
						this.customer_fields.splice(index,1)
				}else if(module=="PO_CUSTOM_FIELD"){
						this.PO_fields.splice(index,1)
				}
		},
		getCustomField(module, index){
			if(module=="CUSTOMER_CUSTOM_FIELD"){
					return this.customer_fields[index];
			}else if(module=="PO_CUSTOM_FIELD"){
						return this.PO_fields[index];
			}
		},
    deleteCustomFields(module,index){
      this.$confirm('En supprimant un champ personnalisé vous allez perdre tous les informations concernant ce champs. Continuer?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning',
          center: true
        }).then(() => {
					let cf = this.getCustomField(module,index);
					SystemAPI.deleteSystemField(cf.id)
						.then(()=>{
							this.splice(module,index);
							this.setCustomFields();
							this.$notify({
								title: 'Succès',
								message: 'Champ personnalisé supprimé avec succès',
								type: 'success'
							});
						})
        })
    },
		setCustomerCustomFields(){
			this.customer_fields=[];
			return SystemAPI.getCustomerCustomFieldDefinition()
		      .then(customerFields=>{
			        _.forEach(customerFields, field=>{
			          var tmp = JSON.parse(field.value);
								tmp.key=parseInt(field.key);
			          tmp.id = field.id;
			          tmp.module = field.module;
								this.customer_fields.push(tmp);
			        })
							return this.customer_fields;
						})
		},
		setPOCustomFields(){
			this.PO_fields=[];
			return SystemAPI.getPOCustomFieldDefinition()
				.then(poFields=>{
					_.forEach(poFields, field=>{
						var tmp = JSON.parse(field.value);
						tmp.key=parseInt(field.key);
						tmp.id = field.id;
						tmp.module = field.module;
						this.PO_fields.push(tmp);
					})
					return this.PO_fields;
				})
		},
		setCustomFields(){
			return this.setCustomerCustomFields()
				.then(()=>{
					return this.setPOCustomFields();
				})
		}
	},
	computed: {

	},
	created(){
		this.setCustomFields()
			.then(()=>{
					this.fullScreenLoading=false;
			})
	}
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.title {
	font-size : 1.8em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:50px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}
</style>
